'use client';

import { RadialBarChart, RadialBar, PolarAngleAxis } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from '../chart';

export interface RadialTextData {
  key: string;
  label: string;
  value: number;
  maxValue?: number;
  color: string;
}

interface RadialTextChartProps {
  data: RadialTextData;
  height?: number;
  className?: string;
}

export function RadialTextChart({ data, height = 220, className }: RadialTextChartProps) {
  const max = data.maxValue ?? 100;
  const config: ChartConfig = { [data.key]: { label: data.label, color: data.color } };

  return (
    <ChartContainer config={config} className={className} style={{ height }}>
      <RadialBarChart
        data={[data]}
        startAngle={90}
        endAngle={-270}
        innerRadius="60%"
        outerRadius="80%"
      >
        <PolarAngleAxis type="number" domain={[0, max]} tick={false} />
        <RadialBar dataKey="value" background fill={`var(--color-${data.key})`} cornerRadius={8} />
        <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle">
          <tspan x="50%" dy="-0.5em" className="fill-foreground text-2xl font-bold">
            {data.value}
          </tspan>
          <tspan x="50%" dy="1.4em" className="fill-muted-foreground text-xs">
            {data.label}
          </tspan>
        </text>
        <ChartTooltip content={<ChartTooltipContent />} />
      </RadialBarChart>
    </ChartContainer>
  );
}
